// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_MapInt = require("rescript/lib/js/belt_MapInt.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var Image$SmartcutsMacros = require("./Image.bs.js");
var CustomMap3$SmartcutsMacros = require("./CustomMap3.bs.js");

function imageResolved_encode(v) {
  if (v.TAG === /* Base64Encoded */0) {
    return [
            "Base64Encoded",
            Decco.stringToJson(v._0)
          ];
  } else {
    return [
            "BlobObject",
            Decco.stringToJson(v._0)
          ];
  }
}

function imageResolved_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Base64Encoded" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Base64Encoded */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "BlobObject" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* BlobObject */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringifyImageResolved(imageResolved) {
  if (imageResolved.TAG === /* Base64Encoded */0) {
    return "Base64Encoded(encodedString)";
  } else {
    return "BlobObject(" + (imageResolved._0 + ")");
  }
}

function t_encode(v) {
  if (typeof v === "number") {
    return ["NoCopiedContentBecauseElementNotFound"];
  } else if (v.TAG === /* CopiedText */0) {
    return [
            "CopiedText",
            Decco.stringToJson(v._0)
          ];
  } else {
    return [
            "CopiedImage",
            imageResolved_encode(v._0),
            Image$SmartcutsMacros.Metadata.t_encode(v._1)
          ];
  }
}

function t_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "CopiedImage" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = imageResolved_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Image$SmartcutsMacros.Metadata.t_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* CopiedImage */1,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "CopiedText" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* CopiedText */0,
                      _0: v0._0
                    }
                  };
          }
          var e$2 = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "NoCopiedContentBecauseElementNotFound" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NoCopiedContentBecauseElementNotFound */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function getText(v) {
  if (typeof v === "number" || v.TAG !== /* CopiedText */0) {
    return ;
  } else {
    return v._0;
  }
}

function getTextExn(v) {
  if (typeof v === "number") {
    return Util$SmartcutsMacros.logAndRaiseJsError("Cannot get text that couldn't be copied due to element not found");
  } else if (v.TAG === /* CopiedText */0) {
    return v._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Cannot get text because this entry is CopiedImage");
  }
}

var ClipboardContent = {
  t_encode: t_encode,
  t_decode: t_decode,
  getText: getText,
  getTextExn: getTextExn
};

function t_encode$1(v) {
  return CustomMap3$SmartcutsMacros.MapIntWithDeccoSupport.t_encode(t_encode, v);
}

function t_decode$1(v) {
  return CustomMap3$SmartcutsMacros.MapIntWithDeccoSupport.t_decode(t_decode, v);
}

function stringify(clipboardByCommandLogIndex) {
  return JSON.stringify(Js_dict.fromArray(Belt_Array.map(Belt_MapInt.toArray(clipboardByCommandLogIndex), (function (param) {
                        var v = param[1];
                        var tmp;
                        tmp = typeof v === "number" ? "NoCopiedContentBecauseElementNotFound" : (
                            v.TAG === /* CopiedText */0 ? v._0 : (
                                v._0.TAG === /* Base64Encoded */0 ? "CopiedImage(Base64Encoded(...), " + (Image$SmartcutsMacros.Metadata.stringify(v._1) + ")") : "CopiedImage(BlobObject, " + (Image$SmartcutsMacros.Metadata.stringify(v._1) + ")")
                              )
                          );
                        return [
                                String(param[0]),
                                tmp
                              ];
                      }))));
}

var ClipboardByCommandLogIndex = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  empty: undefined,
  stringify: stringify
};

exports.imageResolved_encode = imageResolved_encode;
exports.imageResolved_decode = imageResolved_decode;
exports.stringifyImageResolved = stringifyImageResolved;
exports.ClipboardContent = ClipboardContent;
exports.ClipboardByCommandLogIndex = ClipboardByCommandLogIndex;
/* Util-SmartcutsMacros Not a pure module */
